import { render } from "./hotelcard.vue?vue&type=template&id=18bbb899"
import script from "./hotelcard.vue?vue&type=script&lang=js"
export * from "./hotelcard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__